import { default as BSCarousel } from 'bootstrap/js/src/carousel'

class Carousel extends BSCarousel {}

export default Carousel
